export default __webpack_public_path__ + "static/media/des2.285f2363.jpeg";